import { render, staticRenderFns } from "./RecentCommentsWidget.vue?vue&type=template&id=ad159f78&scoped=true"
import script from "./RecentCommentsWidget.vue?vue&type=script&lang=js"
export * from "./RecentCommentsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad159f78",
  null
  
)

export default component.exports